import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { KartOkuyucuKartComponent } from './kart-okuyucu-kart.component';
import { KartOkuyucuEditComponent } from './kart-okuyucu-edit.component';

/**
 * NodeMCU Kart Okuyucu — Dinamik Bileşen
 *
 * Görünümler:
 *  • paylasilmis_kart  → feed/pano kartı (canlı WS durumu gösterir)
 *  • paylas_kutusu     → paylaşım oluştururken parametreleri düzenleme formu
 */
@DinamikBilesen({
  id: 'hmi-kart-okuyucu',
  baslik: 'Kart Okuyucu',
  aciklama: 'NodeMCU RFID/NFC kart okuyucusunun anlık bağlantı ve kart durumunu gösterir',
  ikon: 'credit-card',
  kategori: 'hmi',
  etiketler: ['nodemcu', 'rfid', 'nfc', 'kart', 'websocket'],
  oncelik: 10,
})
class HmiKartOkuyucuBilesen {
  paylasilmis_kart = KartOkuyucuKartComponent;
  paylas_kutusu    = KartOkuyucuEditComponent;
  widget           = KartOkuyucuKartComponent;   // dashboard widget olarak da kullanılabilir
  widget_kucuk     = KartOkuyucuKartComponent;
}
